<template>

    <Toast/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 10px;"></div>

                    <div v-if="this.company.logo != null" class="field">
                        <img :src="imageSrc" alt="Logo" class="form-logo"/>
                    </div>

                    <h3>Process USD Payment</h3>

                    <div style="height: 20px;"></div>

                    <div v-if="company" class="field">
                        <label for="companyName" class="text-900 font-semibold">Company</label>
                        {{ this.company.name }}
                    </div>

                    <div v-if="company" class="field">
                        <label for="companyEmail" class="text-900 font-semibold">Email</label>
                        {{ this.company.email }}
                    </div>

                    <div v-if="companyReference && invoiceReference && signatureReference">
                        <UsdPaymentButton :company-reference="companyReference"
                                          :invoice-reference="invoiceReference"
                                          :signature-reference="signatureReference"/>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import UsdPaymentButton from '@/components/common/UsdPaymentButton.vue';

export default {
    components: {
        UsdPaymentButton,
        IsoEvolveFooter
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[UsdPayment][mounted] System is active.");
            console.log("[UsdPayment][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[UsdPayment][mounted] System is NOT active.");
            console.log("[UsdPayment][mounted] Error = ", e);
            return;
        }

        this.companyReference = this.$route.query.company;
        this.invoiceReference = this.$route.query.invoice;
        this.signatureReference = this.$route.query.signature;

        console.log("[UsdPayment][mounted] companyReference,invoiceReference,signatureReference = ",
            this.companyReference, this.invoiceReference, this.signatureReference);

        try {
            const [companyData] = await Promise.all([
                CompanyService.getCompany(this.companyReference)
            ]);

            this.company = companyData.data;

            this.processImageSrc();

            console.log("[UsdPayment][mounted] this.company = ", this.company);

            this.loading = false;
        } catch (e) {
            console.error("[UsdPayment][mounted] Error fetching additional data = ", e);
        }
    },
    data() {
        return {
            profile: {},
            company: {},
            companyReference: null,
            invoiceReference: null,
            signatureReference: null,
            imageSrc: '',
            errorMessage: '',
            activeTab: 1,
        }
    },
    watch: {},
    computed: {},
    methods: {
        processImageSrc() {
            if (this.company.logo != null) {
                const match = this.company.logo.match(/<img\s+[^>]*src="([^"]+)"/);
                if (match && match[1]) {
                    this.imageSrc = match[1]; // Valid base64 data URL
                    this.errorMessage = ''; // Clear any previous error messages
                } else {
                    this.imageSrc = ''; // Default or empty value
                    this.errorMessage = 'Invalid image data'; // Set an appropriate error message
                }
            }
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

img {
    max-width: 100%;
    height: auto;
}

.form-logo {
    width: clamp(120px, 40vw, 240px);
    height: auto;
    display: block;
    margin: 0 auto;
}
</style>
